module.exports = __webpack_public_path__ + "static/media/email2.745311cf.gif";